module.exports = "/src/views/player/help/images/everyday.jpg";